import {memo} from 'react'
import {Flex} from 'antd'

const ROWS = [1, 2, 3, 4, 5, 6]

const SearchResultsLoading = ({ type }) => {
  const isCircuits = type === 'circuits'

  return (
    <Flex vertical style={{ height: '100%' }}>
      <Flex
        align="center"
        gap={16}
        style={{
          padding: '11px 16px',
          borderBottom: '1px solid var(--color-border-custom)',
        }}
      >
        <div className="skeleton-bar" style={{ width: '30%', height: 14 }} />
        <div className="skeleton-bar" style={{ width: 80, height: 14 }} />
        {isCircuits && (
          <div className="skeleton-bar" style={{ width: '25%', height: 14 }} />
        )}
        <div className="skeleton-bar" style={{ width: '35%', height: 14 }} />
        <div className="skeleton-bar" style={{ width: 70, height: 14 }} />
      </Flex>

      {ROWS.map((row) => (
        <Flex
          key={row}
          align="center"
          gap={16}
          style={{
            padding: '12px 16px',
            borderBottom: '1px solid var(--color-border-custom)',
          }}
        >
          <div className="skeleton-bar" style={{ width: '30%', height: 13 }} />
          <div className="skeleton-bar" style={{ width: 80, height: 13 }} />
          {isCircuits && (
            <div className="skeleton-bar" style={{ width: '25%', height: 13 }} />
          )}
          <div className="skeleton-bar" style={{ width: '35%', height: 13 }} />
          <div className="skeleton-bar" style={{ width: 70, height: 13 }} />
        </Flex>
      ))}
    </Flex>
  )
}

export default memo(SearchResultsLoading)